import { css } from '@emotion/css';

import {
  BaseStyle,
  Display,
  FlexDirection,
  ScreenBreakpoint,
  Spacing,
  TextAlign,
  Color,
  Font,
  BorderRadius,
  FontWeight,
} from '../../styles';

export const faqContainer = css`
  @media (max-width: ${ScreenBreakpoint.laptop.max}) {
    ${Spacing.px20}
  }
`;

export const sectionContainer = css`
  ${Display.flex}
  @media (max-width: ${ScreenBreakpoint.laptop.min}) {
    ${FlexDirection.column}
  }
`;

export const categoryWrapper = css`
  @media (max-width: ${ScreenBreakpoint.laptop.min}) {
    max-width: 100%;
  }
`;

export const categorySelector = css`
  height: 60px;
  ${BaseStyle.level}
  ${Spacing.mb32}
  border: 1px solid ${Color.Brand5};
  ${BorderRadius.xxxs}
  box-shadow: 0 2px 4px 0 rgba(2, 85, 163, 0.15);
  background-color: ${Color.Gray1};
  ${Font.lg}
  ${TextAlign.center}
  @media (max-width: ${ScreenBreakpoint.laptop.max}) {
    height: 50px;
    ${Spacing.mb20}
  }
`;

export const title = css`
  && {
    ${Spacing.mb4}
  }
  ${Font.h3}
  ${FontWeight.semibold}
  color: ${Color.Gray8};
`;

export const subtitle = css`
  ${Font.sm}
  color: ${Color.Gray7};
`;

export const titleWrapper = css`
  ${Spacing.mb32}
  ${Spacing.mt48}
`;

export const questionContainer = css`
  ${Spacing.mb32}
`;

export const question = css`
  && {
    ${Spacing.mb8}
  }
  ${Font.h5}
  ${FontWeight.semibold}
  color: ${Color.Gray8};
`;

export const answer = css`
  ${Font.md}
  color: ${Color.Gray8};
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Font.md}
  }
`;

export const sectionHeader = css`
  ${Spacing.mb16}
  ${Spacing.pb8}
  border-bottom: 1px solid ${Color.Gray7};
`;

export const faqSectionBox = css`
  ${Spacing.pt20}
`;
